import { handleError } from './utils';

// eslint-disable-next-line no-return-await
export const deactivateEntitlement = (id) => handleError(async (dispatch, getState, { api }) => {
  await api.deactivateEntitlement(id);
}, 'There was a problem when trying to get link');

export const createFreeEntitlement = () => handleError(async (dispatch, getState, { api }) => {
  const response = await api.createFreeEntitlement();
  return response;
}, 'There was a problem when trying to validate the Voucher. Please try again later.');
